export * from './Dia';
export * from './DineroInput';
export * from './Fecha';
export * from './ItemEditable';
export * from './LinkAlumno';
export * from './LinkCurso';
export * from './ModalError';
export * from './NombrePersonal';
export * from './SelectDeAlumnos';
export * from './SelectDeCursos';



// WEBPACK FOOTER //
// ./src/componentes/index.ts